import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../mutation-types';
import stockApi from '../../../api/stock';

const defaultState = () => ({
    filter: {
        filter: [{
                value: '',
                comparison: 'bet',
                type: 'date',
                field: 'stock_log_datetime'
            },
            {
                value: '',
                comparison: '=',
                type: 'string',
                field: 'stock_log_daily_product_id'
            },
        ],
        limit: '10',
        page: ''
    },
    stock: [],
    detailRiwayat: {},
    summarySerial: [],
    riwayatStockResults: [],
    riwayatStockPagination: {},
    listStockPagination: {},
    listStockResults: []
});

const state = defaultState();

const getter = {};

const mutations = {
    listStock(state, data) {
        state.stock = data;
    },

    listRiwayatStock(state, data) {
        state.riwayatStockResults = data.data;
        state.riwayatStockPagination = data.pagination;
        state.listStockPagination = {};
        state.filter.page = ''
    },

    listSerial(state, data) {
        state.listStockResults = data.data;
        state.listStockPagination = data.pagination;
        state.riwayatStockPagination = {};
    },

    listDetailRiwayat(state, data) {
        state.detailRiwayat = data;
    },

    listSummarySerial(state, data) {
        state.summarySerial = data;
    }
};

const actions = {
    getStock({ commit, dispatch }) {
        commit(PROGRESS_START, null, { root: true });
        stockApi.getDataStock().then(({ data: { data: { data } } }) => {
            commit('listStock', data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getRiwayatStock({ commit, dispatch }) {
        commit(PROGRESS_START, null, { root: true });
        commit('listRiwayatStock', { data: [], pagination: {} });
        let parameterObject = {}
        let parameter = '{'
        state.filter.filter.forEach((value, index) => {
            for (const [key, val] of Object.entries(value)) {
                parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`
            }
        })
        parameter = parameter.slice(0, -1)
        parameter += `,"limit": "${state.filter.limit}", "page": "${state.filter.page}"`
        parameter += '}'
        parameterObject = JSON.parse(parameter)
        stockApi.getDataStockDaily(parameterObject).then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('listRiwayatStock', { data: 'error', pagination: {} });
            } else {
                commit('listRiwayatStock', { data: data.results, pagination: data.pagination });
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getListSerial({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        commit('listSerial', {data: [], pagination: {}});
        if (value.paramFilter.length > 0) {
            let parameterObject = {}
            let parameter = '{'
            value.paramFilter.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`
                }
            })
            parameter = parameter.slice(0, -1)
            parameter += `,"limit": "${value.limit}", "page": "${value.hal}"`
            parameter += '}'
            parameterObject = JSON.parse(parameter)
            stockApi.getDataStockSerial(parameterObject)
                .then(({ data: { data } }) => {
                    if (data.results.length == 0) {
                        commit('listSerial', { data: 'error', pagination: {} });
                    } else {
                        commit('listSerial', { data: data.results, pagination: data.pagination });
                    }
                    commit(PROGRESS_FINISH, null, { root: true });
                }).catch((err) => {
                    commit('listSerial', { data: 'error', pagination: {} });
                    const { data } = err.response;
                    dispatch('errorHandler', data);
                    commit(PROGRESS_FAIL, null, { root: true });
                });
        } else {
            stockApi.getDataStockSerial({ 'filter[0][value]': value.status, 'filter[0][field]': 'stock_serial_type', 'filter[0][comparison]': '=', 'filter[0][type]': 'string', limit: value.limit, page: value.hal })
                .then(({ data: { data } }) => {
                    if (data.results.length == 0) {
                        commit('listSerial', { data: 'error', pagination: {} });
                    } else {
                        commit('listSerial', { data: data.results, pagination: data.pagination });
                    }
                    commit(PROGRESS_FINISH, null, { root: true });
                }).catch((err) => {
                    commit('listSerial', { data: 'error', pagination: {} });
                    const { data } = err.response;
                    dispatch('errorHandler', data);
                    commit(PROGRESS_FAIL, null, { root: true });
                });
        }
    },

    getDetailStock({ commit, dispatch }, value) {
        commit('listDetailRiwayat', []);
        commit(PROGRESS_START, null, { root: true });
        stockApi.getDataStockLog(value)
            .then(({ data: { data: { results } } }) => {
                commit('listDetailRiwayat', results);
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                const { data } = err.response;
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
    },

    getSummarySerial({ commit, dispatch }) {
        commit('listSummarySerial', []);
        commit(PROGRESS_START, null, { root: true });
        stockApi.summarySerial()
            .then(({ data: { data: { results } } }) => {
                commit('listSummarySerial', results);
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                const { data } = err.response;
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
    },
};

export default {
    namespaced: true,
    state,
    getter,
    mutations,
    actions,
}